export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20product%20display%20with%20clothing%20shoes%20and%20accessories%20arranged%20on%20layered%20wooden%20surfaces%2C%20soft%20golden%20afternoon%20light%20creating%20long%20gentle%20shadows%2C%20editorial%20lifestyle%20product%20photography%2C%20clean%20modern%20composition%2C%20warm%20rich%20earth%20tones%2C%20high%20end%20retail%20aesthetic%2C%20artistic%20arrangement&width=1800&height=800&seq=cta-bg-v2&orientation=landscape"
          alt="ACBuySpreadsheet CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center text-center max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight tracking-wide">
          START SCALING YOUR ACBUY WORKFLOW TODAY
        </h2>

        <p className="mt-5 text-sm md:text-base text-white/75 max-w-xl leading-relaxed">
          Thousands of resellers trust the ACBuySpreadsheet system to track orders, calculate profit, and automate their daily operations. Join them now.
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-white rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-colors group"
        >
          <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-full">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span className="uppercase tracking-wider">Buy It Now</span>
          <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}